export default __webpack_public_path__ + "static/media/edit1.fc14e876.jpg";